import React, {Component} from "react";
import {connect} from "react-redux";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {graphql} from "react-apollo";
import {GET_CUSTOMER, ON_CUSTOMER_UPDATED} from "../../queries/customers";

class CustomerPropertiesPanel extends Component {

  componentDidUpdate(prevProps, prevState) {
    if (this.props.customerId && (prevProps.customerId !== this.props.customerId)) {
      this.subscribe(this.props.customerId);
    }
  }

  subscribe(accountId) {
    if (this.unsubscribeToUpdates) {
      this.unsubscribeToUpdates();
    }
    this.unsubscribeToUpdates = this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let elements = null;
    if (!this.props.customerId) {
      elements = <p className="u-no-selection">Nothing selected</p>
    } else {
      let {loading, error, customer} = this.props.data;
      if (loading) return <Loading />
      if (error) return <GraphQLErrors error={error} />

      let properties = fromJS([
        {prop: "customerId", label: "Id", type: "customerId"},
        {prop: "name", label: "Name", type: "string"},
        {prop: "email", label: "Email", type: "string"},
        {prop: "phone", label: "Phone", type: "telephone"},
        {prop: "referralCode", label: "Ref. Code", type: "id"},
        {prop: "memberSince", label: "Member Since", type: "string"},
        {prop: "authInvited", label: "Auth Invite Sent", type: "boolean"},
        {prop: "authProvisioned", label: "Auth Provisioned", type: "boolean"},
        {prop: "type", label: "Type", type: "string"},
        {prop: "status", label: "Status", type: "string"},
        {prop: "---subs", label: "Subscriptions", type: "category"},
        {prop: "subsActive", label: "Active", type: "integer"},
        {prop: "subsPaused", label: "Paused", type: "integer"},
        {prop: "subsCancelled", label: "Cancelled", type: "integer"},
        {prop: "---policies", label: "Policies", type: "category"},
        {prop: "tacAccepted", label: "Accepted T&C", type: "boolean"},
        {prop: "tacVersion", label: "T&C Version", type: "string"},
        {prop: "marketingAccepted", label: "Marketing", type: "boolean"},
        {prop: "---tags", label: "Tags", type: "category"},
        {prop: "tags", label: "List", type: "tags"},
        {prop: "---promos", label: "Available Promotion", type: "category"},
        {prop: "referralOnboardingPromoType", label: "Type", type: "id"},
        {prop: "referralOnboardingPromoId", label: "Code", type: "id"}
      ])
      elements = <PropertiesList properties={properties} data={fromJS(customer)} />
    }

    return (
      <PanelGroupController title="Customer" expanded={this.props.expanded}>
        {elements}
      </PanelGroupController>
    )
  }

}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_CUSTOMER_UPDATED,
      variables: {
        customerId: props.customerId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withQuery = graphql(GET_CUSTOMER, {
  skip: (props) => !props.customerId,
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      customerId: props.customerId
    }
  })
})

export default connect(null, mapDispatchToProps)(withQuery(CustomerPropertiesPanel));